import React from "react";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { AuthProvider } from './contexts/AuthContext';
import { CompanyProvider } from './contexts/CompanyContext';
import { PermissionProvider } from './contexts/PermissionContext';
import { SidebarProvider } from './contexts/SidebarContext';
import { UserPreferencesProvider } from './contexts/UserPreferencesContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { ToastProvider } from './contexts/ToastContext';
import { ScreenSizeProvider } from './contexts/ScreenSizeContext';
import Routes from './Routes';
import './styles/tailwind.css';

// Create a client with sensible defaults for caching
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes - data considered fresh
      gcTime: 10 * 60 * 1000, // 10 minutes - cache garbage collection (formerly cacheTime)
      retry: 2, // Retry failed requests twice
      refetchOnWindowFocus: false, // Don't refetch when window regains focus
      refetchOnReconnect: true, // Refetch when network reconnects
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider defaultTheme="dark">
        <ScreenSizeProvider>
          <ToastProvider>
            <AuthProvider>
              <UserPreferencesProvider>
                <CompanyProvider>
                  <PermissionProvider>
                    <SidebarProvider>
                      <Routes />
                    </SidebarProvider>
                  </PermissionProvider>
                </CompanyProvider>
              </UserPreferencesProvider>
            </AuthProvider>
          </ToastProvider>
        </ScreenSizeProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;